(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('generalErrorHandler', generalErrorHandler);

    generalErrorHandler.$inject = [];

    function generalErrorHandler() {
        var service = {
            handle: handle
        };

        return service;

        // ----------------------------------------------------------------------

        function handle(reason) {
            switch (reason) {
                case 'tooManyFiles':
                    return createIssue(reason, 'multiple-upload_files-count-exceeded');

                default:
                    return createIssue('UnhandledError', 'general-error');
            }
        }

        function createIssue(code, messageKey) {
            return {
                code: code,
                messageKey: messageKey
            }
        }
    }
})();